export default "__VITE_ASSET__gImEm9f0__"